import React from "react";
import "./SafetyDD.css";

const BASE_URL = process.env.REACT_APP_BASE_URL || "";

function SafetyDD() {
  return (
    <div className="safetyDD-wrapper">
      <ul className="safetyDD-section">
        <a href={`${BASE_URL}/customer-safety`}>
          <li className="safetyDD-option">Customer Safety</li>
        </a>
      </ul>
    </div>
  );
}

export default SafetyDD;
